// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"8b356f85","919":"85d5cf4d"}[chunkId] + ".chunk.js";
};